// What only a school teacher's account has: lessons, school stages / materials / periods, enrolment by period, exams.
import AddLesson from "../../pages/Lessons/AddLesson.js";
import EditLessons from "../../pages/Lessons/EditLesson.js";
import AllLessons from "../../pages/Lessons/AllLessons.js";
import AddSubscriptions from "../../pages/Subscriptions/AddSubscription.js";
import AverageSubscription from "../../pages/Subscriptions/averageSubscription";
import AllSubscriptions from "../../pages/Subscriptions/AllSubscriptions.js";
import AddPeriod from "../../pages/Subscriptions/addPeriod.js";
import AllStudents from "../../pages/Students/AllStudents.js";
import EditStudent from "../../pages/Students/EditStudent.js";
import SubStudents from "../../pages/Students/SubStudents.js";
import SecurityFlags from "../../pages/Students/SecurityFlags.js";
import AddExam from "../../pages/Exams/AddExam.js";
import EditExam from "../../pages/Exams/EditExam.js";
import AllExams from "../../pages/Exams/AllExams.js";
import ViewExams from "../../pages/Exams/ViewExams";
import ExamsReports from "../../pages/Exams/ExamsReports.js";
import EditCommonExam from "../../pages/CommonExams/EditCommonExam.js";
import AddCommonExam from "../../pages/CommonExams/AddCommonExam.js";
import AllCommonExams from "../../pages/CommonExams/AllCommonExams.js";
import Reparation from "../../pages/Reparation/Reparation.js";
import SchoolStages from "../../pages/Settings/SchoolStages.js";
import Materials from "../../pages/Settings/Materials.js";
import Onboarding from "../../pages/Onboarding/Onboarding.js";

import { schoolMenu, schoolMessages } from "../menus";

const school = {
  id: "school",

  messages: schoolMessages,

  // the page a new account lands on after signing up (stages, materials, periods, then the site link)
  Onboarding,

  routes: [
    { path: "/lessons", exact: true, module: "LESSONS", component: AllLessons },
    { path: "/lessons/add", module: "LESSONS", component: AddLesson },
    { path: "/lessons/edit/:id", module: "LESSONS", component: EditLessons },
    { path: "/subscriptions", exact: true, module: "SCHOOL_STRUCTURE", component: AllSubscriptions },
    { path: "/subscriptions/add", module: "SCHOOL_STRUCTURE", component: AddSubscriptions },
    { path: "/students", exact: true, module: "SCHOOL_STRUCTURE", component: AllStudents },
    { path: "/myStudents", exact: true, module: "SCHOOL_STRUCTURE", component: SubStudents },
    { path: "/students/security-flags", exact: true, module: "SCHOOL_STRUCTURE", component: SecurityFlags },
    { path: "/exams/view/:studentId", module: "EXAMS", component: ViewExams },
    { path: "/students/edit/:id", module: "SCHOOL_STRUCTURE", component: EditStudent },
    { path: "/subscriptions/average/", module: "SCHOOL_STRUCTURE", component: AverageSubscription },
    { path: "/subscriptions/addPeriod/", module: "SCHOOL_STRUCTURE", component: AddPeriod },
    { path: "/exams/add", module: "EXAMS", component: AddExam },
    { path: "/exams/edit/:id", module: "EXAMS", component: EditExam },
    { path: "/exams/", exact: true, module: "EXAMS", component: AllExams },
    { path: "/commonQuestions/add", module: "EXAMS", component: AddCommonExam },
    { path: "/commonQuestions/edit/:id", module: "EXAMS", component: EditCommonExam },
    { path: "/commonQuestions/", exact: true, module: "EXAMS", component: AllCommonExams },
    { path: "/reparation/add", exact: true, module: "LESSONS", component: Reparation },
    { path: "/examsReports", exact: true, module: "EXAMS", component: ExamsReports },
    { path: "/settings/school-stages", exact: true, module: "SCHOOL_STRUCTURE", component: SchoolStages },
    { path: "/settings/materials", exact: true, module: "SCHOOL_STRUCTURE", component: Materials },
  ],

  menu: schoolMenu,
};

export default school;
